import { set } from 'es-toolkit/compat';

import { getFeedstockFieldsToSet } from './feedstock.js';
import { feedstockDatabase } from './feedstock-db.js';
import type { IssueMetadata } from './issuance.js';

export const issueSimilarNewMetadata = (originalMetadata: IssueMetadata): Partial<IssueMetadata> => {
  const {
    assuranceLevel: _assuranceLevel,
    fileTool: _fileTool,
    documentationType: _documentationType,
    adjustedLCAChoice: _adjustedLCAChoice,
    adjustedLCAValue: _adjustedLCAValue,
    sustainabilityTier: _sustainabilityTier,
    // Skip some fields, because they are not inheritable (assuranceLevel or susTier)
    // or to require new selection from user (we use object deconstruct syntax because `omit` from es-toolkit does not properly detect all the fields)
    ...newMetadata
  } = structuredClone(originalMetadata);
  const feedstockName = newMetadata.product.feedStock.name;

  const newFieldsToSet = getFeedstockFieldsToSet(feedstockName);
  for (const [path, value] of newFieldsToSet) {
    if (value === undefined) {
      continue; // For issue similar we do not want to reset already set fields, because it makes no sense
    }

    set(newMetadata, path, value);
  }

  if (newMetadata.product.feedStock.isCorsiaDefaultIlucLcaLteZero === undefined) {
    // This was added to allow old certificates be issued-similar under [Issuance V2] Introduced in 03.2026
    const feedstock = feedstockDatabase.find(entry => entry.name === feedstockName);

    if (!feedstock) {
      throw new Error(`Cannot find feedstock: ${feedstockName} in feedstock database`);
    }

    const isCorsiaDefaultIlucLcaLteZero = feedstock.corsiaDefaultIlucLcaLteZeroCb({
      conversionProcess: newMetadata.product.conversionProcess,
      feedstockCountries: newMetadata.product.countries,
    });
    newMetadata.product.feedStock.isCorsiaDefaultIlucLcaLteZero = isCorsiaDefaultIlucLcaLteZero;
  }

  return newMetadata;
};
